import * as React from 'react';

import classNames from 'classnames';
import type { IColorModifier } from '../ColorHelper';
import { getColorModifierClasses } from '../ColorHelper';

export default class Subtitle extends React.Component<IColorModifier, {}> {
	public render() {
		const classes = classNames('subtitle', getColorModifierClasses(this.props));

		return <h2 className={classes}>{this.props.children}</h2>;
	}
}
